export default __webpack_public_path__ + "static/media/service--referencement.2fe92d9b.webp";